import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { CustomersService } from "../../../_services/customers.service";
import { ServiceAddonsService } from "../../../_services/serviceaddons.service";
import { UsedCarAgreement } from "../../../_models/used-cars/usedcaragreement";
import { ServiceAddon } from "../../../_models/serviceaddon";
import { Customer } from "../../../_models/customer";
import { Subscription } from "rxjs";
import {
  ToasterModule,
  ToasterService,
  ToasterConfig,
} from "angular2-toaster/angular2-toaster";
import { EnvironmentService } from "app/_services";

@Component({
  selector: "additional-products",
  templateUrl: "./additional-products.component.html",
  providers: [ServiceAddonsService, CustomersService],
})
export class UsedCarAdditionalProductsComponent implements OnInit {
  private serviceaddons: ServiceAddon[];
  private customer: Customer;
  private customerid: string = "";
  private errorMessage: string = "";
  public isLoading: boolean = true;
  public calculatedPrice: number;
  private serviceaddonslist = [];
  public customer_data: Customer = new Customer();
  public usedCarAgreement: Partial<UsedCarAgreement> = {};

  private subscription: Subscription;

  private toasterService: ToasterService;

  public toasterconfig: ToasterConfig = new ToasterConfig({
    tapToDismiss: true,
    timeout: 5000,
  });

  public dealercalc: boolean;

  private showSearchByReg: boolean = true;

  constructor(
    toasterService: ToasterService,
    private customersService: CustomersService,
    private activatedRoute: ActivatedRoute,
    private serviceAddonsService: ServiceAddonsService,
    private environmentService: EnvironmentService
  ) {
    this.toasterService = toasterService;
    this.activatedRoute = activatedRoute;
  }

  ngOnInit() {
    this.isLoading = false;

    this.activatedRoute.params.subscribe((params) => {
      this.usedCarAgreement = JSON.parse(sessionStorage.getItem("agree"));
      this.customerid = this.usedCarAgreement.customer;
      this.calculatedPrice = this.usedCarAgreement.price;
      this.dealercalc = params["dealercalc"] == "true";
      if (params["regsearch"] && params["regsearch"] == "false") {
        this.showSearchByReg = false;
      }

      this.customersService.read(this.customerid).subscribe(
        /* happy path */ (p) => (this.customer = p),
        /* error path */ (e) => (this.errorMessage = e),
        /* onComplete */ () => {
          this.serviceAddonsService
            .getDealer(this.customer.dealer[0]._id, "usedcars")
            .subscribe(
              /* happy path */ (p) => (this.serviceaddons = p),
              /* error path */ (e) => (this.errorMessage = e),
              /* onComplete */ () => {
                for (var i = 0; i < this.serviceaddons.length; i++) {
                  this.serviceaddons[i].selected = false;
                }
              }
            );
        }
      );
    });
  }

  calculatePrice() {
    let newPrice: number;

    newPrice = this.usedCarAgreement.price;
    this.serviceaddonslist = [];
    for (var i = 0; i < this.serviceaddons.length; i++) {
      if (this.serviceaddons[i].selected) {
        newPrice += this.serviceaddons[i].price;
        this.serviceaddonslist.push(this.serviceaddons[i]);
      }
    }
    this.calculatedPrice = newPrice;
  }

  gotoCheckout(): void {
    this.usedCarAgreement.addons = this.serviceaddonslist;
    this.usedCarAgreement.price = this.calculatedPrice;
    sessionStorage.setItem("agree", JSON.stringify(this.usedCarAgreement));

    top.window.location.href =
      "/#/used-cars/order-flow/checkout/" +
      this.customerid +
      "?regsearch=" +
      (this.showSearchByReg ? "true" : "false") +
      (this.dealercalc ? "&dealercalc=true" : "");
  }

  back() {
    window.history.back();
  }
}



// WEBPACK FOOTER //
// ./src/app/landingpages/usedcars/oder-flow/additional-products.component.ts